import { render } from "./IndividualPage.vue?vue&type=template&id=f26896d0&scoped=true&ts=true"
import script from "./IndividualPage.vue?vue&type=script&lang=ts"
export * from "./IndividualPage.vue?vue&type=script&lang=ts"

import "./IndividualPage.vue?vue&type=style&index=0&id=f26896d0&scoped=true&lang=css"

import exportComponent from "E:\\dyy\\备份\\百廿官网\\bnkjgw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f26896d0"]])

export default __exports__